import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { emailRegex, FormState } from '@opu/utils';
import AxiosInstance from '../../../helpers/AxiosInstance';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useForm = (optionsToDisplay) => {
  const { addButton, editAction, deleteAction } = optionsToDisplay;

  const [listOpuUser, setListOpuUser] = useState([]);
  const [totalItems, setTotalItems] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [query, setQuery] = useState({ page: null, order: 'firstName DESC', keyword: '', limit: 10 });

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = parseInt(queryParams.get('page'));
    const order = queryParams.get('order');
    const keyword = queryParams.get('keyword');
    setQuery((prev) => ({
      ...prev,
      page: page ? page - 1 : 0,
      order: order ? order : query.order,
      keyword: keyword ? keyword : '',
    }));
  }, [location]);

  useEffect(() => {
    if (query.page !== null) {
      findAllOpuUsers();
    }
  }, [query]);

  const findAllOpuUsers = () => {
    setLoading(true);
    AxiosInstance.get('/opu-user', { params: query })
      .then((response) => {
        setListOpuUser(response.data.items);
        setTotalPages(response.data.totalPages);
        setTotalItems(response.data.totalItems);
        setLoading(false);
      })
      .catch((error) => {
        Swal.fire(t('opu-user.ERROR_GET_OPU_USERS'), '', 'error');
        setLoading(false);
      });
  };

  const updateOpuUser = (id) => {
    history.push({
      pathname: '/opu-user/update',
      params: {
        id: id,
      },
    });
  };

  const deleteOpuUser = (id) => {
    Swal.fire({
      title: t('swal.are_you_sure'),
      text: t('swal.delete_permanently'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: t('swal.no'),
      confirmButtonText: t('swal.yes_delete'),
    }).then((result) => {
      if (result.isConfirmed) {
        AxiosInstance.delete('/opu-user/' + id)
          .then((response) => {
            Swal.fire(t('opu-user.SUCCESS_DELETE_OPU_USER'), '', 'success');
            findAllOpuUsers();
          })
          .catch((error) => {
            Swal.fire(t('opu-user.ERROR_DELETE_OPU_USER'), '', 'error');
          });
      }
    });
  };

  const attributes = [
    { name: 'firstName', title: t('table.firstName'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'lastName', title: t('table.lastName'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'email', title: t('table.email'), nestedObject: ['user'], type: 'text', order: true },
    { name: 'role', title: t('table.role'), nestedObject: [], type: 'text', order: true, translate: true },
    { name: 'phone', title: t('table.phone'), nestedObject: ['user'], type: 'text', order: false },
    { name: 'isVerified', title: t('table.isVerified'), nestedObject: ['user'], type: 'verified_status', order: false },
    { name: 'creationDate', title: t('table.creationDate'), nestedObject: ['user'], type: 'date', order: false },
  ];

  const actions = { details: null, delete: deleteAction && deleteOpuUser, update: editAction && updateOpuUser };

  return {
    attributes,
    actions,
    listOpuUser,
    findAllOpuUsers,
    totalPages,
    loading,
    query,
  };
};

export default useForm;
